$(document).ready(function () {
    // console.log("ready");

    $("a").each(function () {
        if ($(this).data("href")) {
            $(this).click(function (e) {
                if ($($(this).data("href")).length) {
                    e.preventDefault();

                    var vpWidth = $("#container").width();

                    if ($("#container").width() >= 768) {
                        var offset = 120;
                    } else {
                        var offset = 85;
                    }

                    $(".navbar-collapse.show").removeClass("show");

                    // console.log(vpWidth, offset);

                    $("html, body").animate(
                        {
                            scrollTop:
                                $($(this).data("href")).offset().top - offset,
                        },
                        500,
                        "linear"
                    );
                }
            });
        }
    });

    $("div.top_link").hide();
    $(window).scroll(function () {
        var value = 2500;
        var scrolling = $(window).scrollTop();
        if (scrolling > value) {
            $("div.top_link").fadeIn();
        } else {
            $("div.top_link").fadeOut();
        }
    });
    $("div.top_link").click(function (e) {
        e.preventDefault();

        $("html, body").animate(
            {
                scrollTop: 0,
            },
            500,
            "linear"
        );
        return false;
    });

    $(".highlight-primary table, .highlight-secondary table").wrap(
        '<div class="table-wrap">'
    );
});
